import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NavService } from '../../core/nav.service';
import { Course } from '../../courses/shared/course';
import { CourseLectureService } from '../../courses/shared/course-lecture.service';
import { ListObservable } from '../../shared/base/list-observable';
import { ObjectObservable } from '../../shared/base/object-observable';
import { Lecture } from '../shared/lecture';

@Component({
  selector: 'app-lecture-detail',
  templateUrl: './lecture-detail.component.html'
})
export class LectureDetailComponent implements OnInit {
  courseObservable: ObjectObservable<Course>;
  lectureObservable: ObjectObservable<Lecture>;
  lecturesObservable: ListObservable<any>;

  constructor(private route: ActivatedRoute, private nav: NavService, private refService: CourseLectureService) { }

  ngOnInit() {
    this.initNav();
    this.route.data.subscribe((data: { lecture: ObjectObservable<Lecture> }) => {
      this.lectureObservable = data.lecture;
    });

    this.route.parent.data.subscribe((data: { course: ObjectObservable<Course> }) => {
      if (data.course) {
        this.courseObservable = data.course;
        this.lecturesObservable = this.refService.readList(data.course.$ref.key, 'name');
      }
    });
  }

  private initNav(): void {
    this.nav.title = '강의 내용';
    this.nav.actions = [
      { text: '강좌로 돌아가기', commands: ['.'], route: this.route.parent }
    ];
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-detail/lecture-detail.component.ts